import $fn from '@/utils/fn.ts';
import httpApi from '@/apis/httpApi'
import http from "@/utils/http.js"

// 用户名密码注册
interface ForgetPasswordJson {
	username: string,
}
export const forgetPassword = (json: ForgetPasswordJson): any => http.httpPost({
	url: httpApi.forget.forgetPassword,
	json,
})

// 验证手机验证码
interface VerifyCodeJson {
	phone: string,
	code: string,
}
export const verifyCode = (json: VerifyCodeJson): any => http.httpPost({
	url: httpApi.forget.verifyCode,
	json,
})

// 忘记密码-修改密码
interface PhoneEditPasswordJson {
	phone: string,
	newpassword: string,
}
export const phoneEditPassword = (json: PhoneEditPasswordJson): any => http.httpPost({
	url: httpApi.forget.phoneEditPassword,
	json,
})

// 手机验证码修改绑定手机
interface EditBindingPhoneJson {
	old_phone: string,
	new_phone: string,
	code: string,
}
export const editBindingPhone = (json: EditBindingPhoneJson): any => http.httpPost({
	url: httpApi.forget.editBindingPhone,
	json,
})

// 手机验证码修改绑定手机
interface BindPhoneJson {
	phone: string,
	code: string,
}
export const bindPhone = (json: BindPhoneJson): any => http.httpPost({
	url: httpApi.forget.bindPhone,
	json,
})

// 手机验证码修改绑定手机
interface ChangePwdJson {
	username: string,
	password: string,
	newpassword: string,
}
export const changePwd = (json: ChangePwdJson): any => http.httpPost({
	url: httpApi.forget.changePwd,
	json,
})

